<div class="filter-date-time-range">
  <div class="filter-date-time-range__range">
    <div class="filter-date-time-range__range-from">
      <app-filter-date-time
        [ngModel]="dateRange?.from"
        (ngModelChange)="onChangeFromDate($event)"
        [maxDate]="maxDateFrom"></app-filter-date-time>
    </div>
    <div class="filter-date-time-range__range-and">
      {{ "events.company-call-history.filters.and" | Translate }}
    </div>
    <div class="filter-date-time-range__range-to">
      <app-filter-date-time
        [ngModel]="dateRange?.to"
        (ngModelChange)="onChangeToDate($event)"
        [minDate]="minDateTo"></app-filter-date-time>
    </div>
  </div>
  <div class="filter-date-time-range__times">
    <div
      class="filter-date-time-range__times-row"
      *ngFor="let timeRange of timeRanges; let idx = index">
      <button
        type="button"
        class="vox-btn filter-date-time-range__times-remove"
        (click)="onRemoveTimeRange(idx)"
        [disabled]="timeRanges.length === 1">
        -
      </button>
      <app-filter-time-range
        (changeTimeRange)="onTimeRangeChange($event, idx)"
        [fromTime]="timeRange.from_time"
        [toTime]="timeRange.to_time"></app-filter-time-range>
    </div>
    <div class="filter-date-time-range__times-row">
      <button
        type="button"
        class="vox-btn filter-date-time-range__times-add"
        (click)="onAddTimeRange()">
        +
      </button>
    </div>
  </div>
</div>
